import React, { useState, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import { WithStyles, StyleRules } from '@mui/material/styles/withStyles';
import { Theme } from '@mui/material/styles';
import { Grid, Typography } from "@mui/material";
import * as request from 'superagent';
import LoadingView from '~common/components/loading-view';
import ErrorView from '~common/components/error-view';
import MFAMethodSelect from "../components/mfa-method-select"
import MFAEmailSetup from "../components/mfa-email-setup"
import MFAAuthenticatorSetup from "../components/mfa-authenticator-setup"
import PortalUserContext from '~common/lib/portal-user-context';
import Renderers from "~common/lib/renderers";
import ConfirmYesNo from "~common/components/modal/yes-no-modal"

const styles = (theme: Theme): StyleRules => ({

});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  match: any;
}

const MFAPreferences: React.FC<Props & WithStyles<keyof typeof styles>> = (props) => {

    const [status, setStatus] = useState("loading");
    const [method, setMethod] = useState({});
    const [alreadyVerified, setAlreadyVerified] = useState(undefined);
    const [enrolledMethod, setEnrolledMethod] = useState(undefined)
    const [userIneligible, setUserIneligible] = useState(undefined);
    const [qr, setQR] = useState(undefined);
    const [setupCode, setSetupCode] = useState(undefined);
    const [error, setError] = useState(null);
    const [enrollSuccess, setEnrollSuccess] = useState(undefined);
    const [confirmUnEnroll, setConfirmUnEnroll] = useState(undefined)


  const handleMethodChange = (method: string) => {
    setMethod(method);
  };

  const onSetupSuccess = () => {
    setEnrollSuccess(true)
  }

  const confirmRemoveMFA = () => {
    setConfirmUnEnroll(true)
  }

  const cancelConfirmRemoveMFA = () => {
    setConfirmUnEnroll(false)
  }

  const goMFASetup = () => {
    window.location.href = "/users/enroll-otp"
  }

  const unEnroll = () => {
    request.put("/api/auth/users/otp-un-enroll").then(()=>{
      window.location.reload()
    }).catch((err)=>{
      handleAPIError(err);
    })
  }

  const handleAPIError = (err: any) => {
    setError(err);
  };

  const onErrorViewClose = () => {
    setError(null);
  };

  useEffect(() => {
    var {mfaEnabled} = (window as any).App
    if (mfaEnabled !== true) {
      setStatus("disabled")
    } else {
      request.get("/api/auth/users/init-otp-enroll")
        .then((response: request.Response) => {
          if (response.body.alreadyVerified) {
            setStatus("ready");
            setAlreadyVerified(true);
            setEnrolledMethod(response.body.enrolledMethod)
          } else  {
            if (response.body.userIneligible) {
              setStatus("ready");
              setUserIneligible(true);
            } else {
              if (response.body.qr) {
                setQR(response.body.qr);
                setSetupCode(response.body.key);
              }
              setStatus("ready");
            }
          }
        })
        .catch((err) => {
          handleAPIError(err);
        });
    }
  }, []);

  var confirmModal: any;
  if (confirmUnEnroll) {
        confirmModal = (
            <ConfirmYesNo
              title={"Confirm MFA Un-Enroll"}
              confirmMessage={"Are you sure want remove multi-factor authentication?"}
              open={true}
              handleYes={unEnroll}
              handleNo={cancelConfirmRemoveMFA}
        />
        )
  }

  if (status == "disabled") {
    return <div></div>
  }

  let errorView;
  if (error) {
    errorView = <ErrorView classes={{}} error={error} onClose={onErrorViewClose} />;
  }

  var view: any;
  if (status == "loading") {
    view = <LoadingView classes={{}} />
  }

  if (status == "ready") {
    view = (
        <div>

            {confirmModal}

            {alreadyVerified &&
                <Grid container spacing={8}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography variant="subtitle1">
                        You have already enrolled for multi-factor authentication using the {enrolledMethod} method.
                    </Typography>
                    <Typography variant="subtitle1">
                        Click <a style={{cursor: "pointer", color: "blue"}} onClick={confirmRemoveMFA}>here</a> to un-enroll.
                    </Typography>
                    </Grid>
                </Grid>
            }

            {userIneligible && 
                <Grid container spacing={8}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography variant="subtitle1">
                      You are not eligible to enroll for multi-factor authentication.
                    </Typography>
                  </Grid>
                </Grid>
              }

            {enrollSuccess &&
                <Grid container spacing={8}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography variant="subtitle1">
                        You have succesfully enrolled for multi-factor authentication.
                    </Typography>
                    </Grid>
                </Grid>
            }

            {!alreadyVerified && !enrollSuccess && !userIneligible &&
                <div>
                    <Grid container spacing={8}>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="subtitle1">
                            You have not set-up multi-factor authentication yet.
                        </Typography>
                        <Typography variant="subtitle1">
                            Click <a style={{cursor: "pointer", color: "blue"}} onClick={goMFASetup}>here</a> to enroll.
                        </Typography>
                      </Grid>
                  </Grid>
                </div>
            }

        </div>
    )
  }

  console.log("confirmUnEnroll", confirmUnEnroll)

  return (
    <div style={{paddingLeft: 15}}>
        
        {errorView}

        <Typography style={{color: "#555", marginBottom: 20}} variant="h6" >Multi-Factor Authentication</Typography>

        {view}
       
    </div>
  )
};

MFAPreferences.register = () => {
    if (!Renderers.find("mfaPreferencesView")) {
        Renderers.register("mfaPreferencesView", MFAPreferences);
    }
}

export default withStyles(styles)(MFAPreferences);